<template>
  <div class="page flex-col">
    <SideBar ref="sidebarRef" />
    <div class="text-wrapper_1 flex-row">
      <span class="text_1">请选择您的面试官</span>
    </div>
    <div class="body">
      <div class="cards-container">
        <div v-for="(item, index) in items" :key="item.id" :id="`card-${item.id}`" class="card"
          :class="getPositionClass(index)" @click="handleCardClick(index)" :style="{
            backgroundImage: `url(${item.image})`,
            cursor: isCardClickable(index + 2) ? 'pointer' : 'default',
            opacity: isCardUnlocked(index) ? 1 : 0.5 // 未解锁图片透明度降低
          }">
          <!-- 锁定图标和玻璃遮罩 -->
          <div v-if="!isCardUnlocked(index)" class="glass-overlay">
            <span>待解锁</span>
          </div>
        </div>
      </div>
    </div>
    <div class="group_2 flex-row justify-between" v-show="!isFeedbackModalVisible">
      <div class="text-wrapper_2 flex-col" @click="handleConfirmClick">
        <span class="text_2">确定</span>
      </div>
      <div class="text-wrapper_3 flex-col" @click="gotodashboard">
        <span class="text_3">上一步</span>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar/index.vue';
export default {
  data() {
    return {
      // 当前中央位置的卡片索引（0-4对应实际的索引位置）

      centerIndex: 2,
      isFeedbackModalVisible: false,
      items: [
        { id: 1, image: require("./assets/img/FigmaDDSSlicePNGf572066d2c45e535a99cf96eeb83de71.png") },
        { id: 2, image: require("./assets/img/img3.png") },
        // { id: 3, image: require("./assets/img/FigmaDDSSlicePNG924f02b8cbc2386685425ddf737bb427.png") },
        { id: 3, image: require("../interview_ing/assets/img/quiet_Scene1.gif") },
        { id: 4, image: require("./assets/img/FigmaDDSSlicePNGd563392063a91d9f390b8eb7978773f7.png") },
        { id: 5, image: require("./assets/img/FigmaDDSSlicePNG9ee27825cd397536c990e8af40b6679d.png") }
      ]
    };
  },
  components: {
    SideBar
  },
  mounted() {
    // 获取SideBar组件引用并监听其showFeedback变量
    this.$nextTick(() => {
      // 如果SideBar组件中有事件总线或公开的方法，使用它
      // 这里使用一个简单的MutationObserver来监视DOM中反馈模态框的出现
      this.observeFeedbackModal();
    });
  },
  methods: {
    observeFeedbackModal() {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            const feedbackModal = document.querySelector('.feedback-modal');
            this.isFeedbackModalVisible = !!feedbackModal;
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    },


    // 判断卡片是否已解锁
    isCardUnlocked(index) {
      return index === 2; // 只有第一张图片是解锁的
    },

    // 判断卡片是否可点击
    isCardClickable(index) {
      return this.isCardUnlocked(index); // 只有解锁的卡片可以点击
    },

    // 处理卡片点击事件
    handleCardClick(index) {
      if (!this.isCardClickable(index)) {
        this.$message({
          message: '该角色尚未解锁~',
          type: 'warning',
          duration: 2000
        });
        return;
      }

      console.log('选择了第一张图片:', this.items[index]);
      this.centerIndex = index; // 更新中心索引
    },



    confirmSelection() {
      const selectedInterviewer = this.items[this.centerIndex];
      console.log('选择的面试官:', selectedInterviewer);
      return selectedInterviewer.id;
    },

    handleConfirmClick() {
      const selectedId = this.confirmSelection();
      if (selectedId === 1) {
        this.$router.push({ path: '/store/interview_pre', query: { selectedId: selectedId } });
      } else {
        this.$message({
          message: '其他数字人正在开发中~',
          type: 'warning',
          duration: 2000
        });
      }

    },
    // 监视DOM中反馈模态框的出现
    observeFeedbackModal() {
      // 创建MutationObserver检测弹窗元素
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            // 检查是否存在feedback-modal元素
            const feedbackModal = document.querySelector('.feedback-modal');
            this.isFeedbackModalVisible = !!feedbackModal;
          }
        }
      });

      // 开始观察body元素的子节点变化
      observer.observe(document.body, { childList: true, subtree: true });
    },
    // 根据索引与中心位置的相对关系，返回对应的位置类名
    getPositionClass(index) {
      // 计算相对于中心位置的偏移
      let relativePos = (index - this.centerIndex + 5) % 5;

      // 根据相对位置返回类名
      return `position-${relativePos}`;
    },

    // 判断卡片是否可点击（只有中间卡片左右相邻的卡片才可点击）
    isCardClickable(index) {
      // 计算相对于中心位置的偏移
      let relativePos = (index - this.centerIndex + 5) % 5;

      // 只有相对位置为1（右侧相邻）或4（左侧相邻）的卡片可点击
      return relativePos === 1 || relativePos === 4;
    },

    // 处理卡片点击事件
    handleCardClick(index) {
      // 如果点击的不是可点击的卡片，直接返回
      if (!this.isCardClickable(index)) return;

      // 计算相对于中心位置的偏移
      let relativePos = (index - this.centerIndex + 5) % 5;

      if (relativePos === 1) {
        // 点击右侧卡片，所有卡片向左移（中心索引加1）
        this.centerIndex = (this.centerIndex + 1) % 5;
      } else if (relativePos === 4) {
        // 点击左侧卡片，所有卡片向右移（中心索引减1）
        this.centerIndex = (this.centerIndex - 1 + 5) % 5;
      }
      
    },

    gotodashboard() {
      // 返回上一页
      this.$router.push({ path: '/dashboard' });
    },
    confirmSelection() {
      // 获取当前选择的面试官
      const selectedInterviewer = this.items[this.centerIndex];
      console.log('选择的面试官:', selectedInterviewer);
      return selectedInterviewer.id;
    },

    handleConfirmClick() {
      const selectedId = this.confirmSelection();
      if (selectedId === 3) {
        this.$router.push({ path: '/store/interview_pre', query: { selectedId: selectedId } });
      } else {
        this.$message({
          message: '其他数字人正在开发中~',
          type: 'warning',
          duration: 2000
        });
      }
    }
  }
};
</script>

<style scoped lang="css" src="./assets/index.response.css" />

<style scoped>
.glass-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px);
  /* 玻璃效果 */
  background-color: rgba(0, 0, 0, 0.2);
  /* 半透明遮罩 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: bold;
}



.position-1:hover,
.position-4:hover {
  filter: brightness(1.1);
  box-shadow: 0 0.5vw 3vw rgba(126, 180, 235, 0.5);
}

.group_2 {
  position: relative;
  z-index: 20;
  margin-top: 2vh;
}

.text-wrapper_2,
.text-wrapper_3 {
  cursor: pointer;
}

/* 自定义样式，覆盖原有CSS */
.body {
  width: 100vw;
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10vh;
  margin-bottom: 5vh;
}

.cards-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 70vw;
  height: 60vh;
}

.card {
  position: absolute;
  height: 60vh;
  width: 13vw;
  /* 调整后的宽度 */
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.3);
  transition: all 0.5s ease;
  -webkit-box-reflect: below 2.5vw -webkit-linear-gradient(transparent 60%, rgba(255, 255, 255, 0.2));
}

/* 定义5个位置的样式 */
/* 中间位置 */
.position-0 {
  transform: translateX(0) scale(1);
  z-index: 5;
}

/* 右侧相邻位置 */
.position-1 {
  transform: translateX(14vw) scale(0.9);
  z-index: 4;
}

/* 右侧第二个位置 */
.position-2 {
  transform: translateX(26vw) scale(0.8);
  z-index: 3;
}

/* 左侧相邻位置 */
.position-4 {
  transform: translateX(-14vw) scale(0.9);
  z-index: 4;
}

/* 左侧第二个位置 */
.position-3 {
  transform: translateX(-26vw) scale(0.8);
  z-index: 3;
}

/* 增强可点击卡片的视觉效果 */
.card:hover {
  filter: brightness(1.05);
}

.position-1:hover,
.position-4:hover {
  filter: brightness(1.1);
  box-shadow: 0 0.5vw 3vw rgba(126, 180, 235, 0.5);
}

/* 左右控制区域 */

/* 增强选中效果 */
.item.selected {
  filter: drop-shadow(0 0 15px rgba(126, 180, 235, 0.8));
  z-index: 5;
}

.selection-border {
  position: absolute;
  inset: -3px;
  border: 3px solid rgba(126, 180, 235, 1);
  border-radius: 8px;
  animation: pulse-border 2s infinite;
  z-index: 6;
}

/* 确保下方按钮不被遮挡 */
.group_2 {
  position: relative;
  z-index: 20;
  margin-top: 2vh;
}

.shell {
  height: 60vh;
}

.text-wrapper_2,
.text-wrapper_3 {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>